import { Box } from '@mui/material';
import { IRequestType } from '../../../constants/interfaces';
import { HomeMenu } from '../HelperComponents';
import { dashboardCardSx } from '../../../styles/requestFormShell';

interface StyleClasses {
  button: string;
  content: string;
  error: string;
  errorCenter: string;
  header: string;
  headerControls: string;
  homeMenu: string;
  input: string;
  menuButtonContainer: string;
  sectionTitle: string;
  toggleMargin: string;
}

interface RequestTypesPanelProps {
  classes: StyleClasses;
  sortedRequestTypes: IRequestType[];
  onMenuItemClick: (type: IRequestType) => void;
}

const RequestTypesPanel = ({
  classes,
  sortedRequestTypes,
  onMenuItemClick,
}: RequestTypesPanelProps) => {
  return (
    <Box
      aria-label="Request types"
      component="section"
      sx={{
        ...dashboardCardSx,
        flex: { md: '0 0 350px', xs: 1 },
        height: 'fit-content',
      }}
    >
      <Box sx={{ p: 2.5 }}>
        <HomeMenu
          classes={classes}
          sortedRequestTypes={sortedRequestTypes}
          onMenuItemClick={onMenuItemClick}
        />
      </Box>
    </Box>
  );
};

export default RequestTypesPanel;
